module.exports = __webpack_public_path__ + "static/media/Reylight-Regular.fab12781.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Reylight-Regular.woff
// module id = 2236
// module chunks = 53